import { createAction, props } from '@ngrx/store';
import { RdsToastIndividualConfig } from '@rds/angular-components';

export const showToast = createAction(
  '[TOAST] Show toast',
  props<{ message?: string, title?: string, options?: Partial<RdsToastIndividualConfig>  }>()
);
